import { createElementFromString, getScrollbarWidth } from '../helper/helper';

export default class Modal {
	constructor(trigger) {

		if (undefined === window.hpyModals) {
			window.hpyModals = [];
		}

		window.hpyModals.push(this);

		// this.triggerSelector = triggerSelector;
		// this.trigger = document.querySelectorAll(triggerSelector);
		this.trigger = trigger;
		this.selector = this.trigger.getAttribute('aria-controls')
		this.content = document.querySelector(this.selector);

		if (!this.trigger || !this.content) {
			return;
		}

		this.modal = {
			mask: document.querySelector('#modal-' + this.selector.replace('#', ''))
		};
		this.state = {
			shown: false,
		}

		this.setupModal();

		jQuery(this.trigger).on('click', this.openModal.bind(this));

		jQuery(this.modal.mask).on('click', (e) => {
			if (e.target === this.modal.mask) {
				this.closeModal(e);
			}
		});
		this.modal.close.addEventListener('click', this.closeModal.bind(this));
	}

	openModal(e) {
		e.preventDefault();

		if (false === jQuery(document.body).triggerHandler('tooltip_maybe_open')) {
			return;
		}

		gsap.to(this.modal.mask, {
			opacity: 1,
			duration: 0.3,
			onStart: () => {
				this.modal.mask.style.display = 'flex';
				document.documentElement.style.overflow = 'hidden';
			},
			onComplete: () => {
				this.state.shown = true;
				jQuery(document.body).trigger('tooltip_open', [this]);
			}
		});
	}

	closeModal(e) {
		e.preventDefault();

		const tooltip = this.modal.mask.querySelector('.tooltip--content');
		const tooltipSelector = tooltip.id;

		gsap.to(this.modal.mask, {
			opacity: 0,
			display: "none",
			duration: 0.3,
			onComplete: () => {
				this.state.shown = true;
				document.documentElement.style.overflow = '';
				jQuery(document.body).trigger('tooltip_close', [this]);
			}
		});
	}

	setupModal() {
		const scrollbarWidth = getScrollbarWidth();

		this.modal.mask.style.width = `calc( 100% + ${scrollbarWidth}px )`;
		this.modal.close = this.modal.mask.querySelector('.modal--close');
		this.modal.content = this.modal.mask.querySelector('.modal--content');
	}
}
